import React from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import components
import SearchFormField from './SearchFormField.js';
import SearchFormSelect from './SearchFormSelect.js';

const SearchForm = ({ handleSubmit, submitting, isLoading, clang, searchOptions, searchOptionsFiles, isMainPage, pristine, currentKey, initialValues, isFilesSearch }) => {
    return (
        <form onSubmit={handleSubmit} className="search-bar__form">
            <Field 
                component={SearchFormSelect} 
                name="area" 
                label={lang[clang].search.where} 
                isMainPage={isMainPage} 
                isAllSearch={isFilesSearch}
                props={{
                    options: searchOptions
                    // options: isFilesSearch ? searchOptionsFiles : searchOptions
                }}
            />
            <Field component={SearchFormField} type="text" name="key" label={lang[clang].search.what}/>

            <div className="search-bar__form-submit">
              <button 
                type="submit" 
                disabled={!currentKey || !currentKey.trim() || ["%20", "%2B"].includes(encodeURIComponent(currentKey)) || submitting || isLoading} 
                title={lang[clang].search_for}
              >
                  <span className="search-bar__form-submit__img"></span>
              </button>
            </div>
        </form>
    );
};

SearchForm.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(reduxForm({
    form: 'search',
    enableReinitialize: true
})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/search/SearchForm.js